import React, { Component } from 'react'
import { FormGroup, FormControlLabel, Checkbox, TextField } from '@mui/material'

import SelectRC, { Option } from 'rc-select'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class DisplayItemFileSettings extends Component {
    constructor(props) {
        super(props)

        const kedo = props.kedo
        const selected = []

        const fileTypes = props.item?.settings?.file_types
        if (Array.isArray(fileTypes)) {
            fileTypes.forEach((item) => {
                let label = item.charAt(0).toUpperCase() + item.slice(1)
                if (item === 'images') {
                    label = kedo.t('Images')
                }
                if (item === 'documents') {
                    label = kedo.t('Text documents')
                }
                if (item === 'spreadsheet') {
                    label = kedo.t('Spreadsheet documents')
                }
                if (item === 'presentation') {
                    label = kedo.t('Presentation documents')
                }

                selected.push({
                    label: label,
                    value: item,
                })
            })
        }

        const options = [
            // {value: '', label: 'Everything'},
            { value: 'images', label: kedo.t('Images') },
            { value: 'audio', label: 'Audio' },
            { value: 'video', label: 'Videos' },
            { value: 'documents', label: kedo.t('Text documents') },
            { value: 'spreadsheet', label: kedo.t('Spreadsheet documents') },
            { value: 'presentation', label: kedo.t('Presentation documents') },
        ]

        this.state = {
            multiple: this.props.item?.settings?.multiple ? true : false,
            file_preview: this.props.item?.settings?.file_preview
                ? true
                : false,
            preview_direct: this.props.item?.settings?.preview_direct
                ? true
                : false,
            preview_width: this.props.item?.settings?.preview_width
                ? this.props.item.settings.preview_width
                : null,
            preview_height: this.props.item?.settings?.preview_height
                ? this.props.item.settings.preview_height
                : null,
            signature: this.props.item?.settings?.signature ? true : false,
            options: options,
            selected: this.props.item?.settings?.file_types ? selected : [],
        }

        this.onChange = this.onChange.bind(this)
        this.onNormalChange = this.onNormalChange.bind(this)
        this.onChangeFileTypeOptions = this.onChangeFileTypeOptions.bind(this)
    }

    onChangeFileTypeOptions(options) {
        const selectedOptions = options || []
        this.setState({ selected: selectedOptions })

        const values = selectedOptions.map((item) => item.value)
        this.props.onChange('file_types', values)
    }

    onChange(event) {
        if (event.target.checked === true) {
            this.setState({ [event.target.name]: true })
            this.props.onChange(event.target.name, true)
        } else {
            this.setState({ [event.target.name]: false })
            this.props.onChange(event.target.name, false)
        }
    }

    onNormalChange(event) {
        this.setState({ [event.target.name]: event.target.value })
        this.props.onChange(event.target.name, event.target.value)
    }

    render() {
        const filteredOptions = this.state.options.filter(
            (option) =>
                !this.state.selected.some(
                    (selected) => selected.value === option.value
                )
        )

        return (
            <div>
                <FormGroup>
                    <FormInputLabel>
                        {this.props.kedo.t('Restrict file uploads')}
                    </FormInputLabel>
                    <SelectRC
                        className="w-100 custom-select-react"
                        id={`file-settings`}
                        mode="multiple"
                        allowClear
                        onChange={(selectedItems) => {
                            const selectedOptions = selectedItems.map(
                                (selectedItem) =>
                                    this.state.options.find(
                                        (option) =>
                                            option.value === selectedItem.value
                                    )
                            )
                            this.onChangeFileTypeOptions(selectedOptions)
                        }}
                        suffixIcon={<FontAwesomeIcon icon={faChevronDown} />}
                        placeholder={
                            this.props.kedo.t('Select an option') + '...'
                        }
                        value={this.state.selected.map((item) => ({
                            value: item.value,
                            label: item.label,
                        }))}
                        labelInValue
                        notFoundContent={this.props.kedo.t('No items found')}
                    >
                        {filteredOptions.map((option) => (
                            <Option key={option.id} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </SelectRC>
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.multiple}
                                onChange={this.onChange}
                                name="multiple"
                            />
                        }
                        label={this.props.kedo.t('Allow multiple files')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.file_preview}
                                onChange={this.onChange}
                                name="file_preview"
                            />
                        }
                        label={this.props.kedo.t('Show file preview')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.preview_direct}
                                onChange={this.onChange}
                                name="preview_direct"
                            />
                        }
                        label={this.props.kedo.t('Direct preview')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.signature}
                                onChange={this.onChange}
                                name="signature"
                            />
                        }
                        label={this.props.kedo.t('Signature')}
                    />
                </FormGroup>
                <FormGroup>
                    <FormInputLabel>
                        {this.props.kedo.t('Width')}
                    </FormInputLabel>
                    <TextField
                        type="number"
                        name="preview_width"
                        value={this.state.preview_width}
                        onChange={this.onNormalChange}
                        variant="outlined"
                        fullWidth
                    />
                </FormGroup>
                <FormGroup>
                    <FormInputLabel>
                        {this.props.kedo.t('Height')}
                    </FormInputLabel>
                    <TextField
                        type="number"
                        name="preview_height"
                        value={this.state.preview_height}
                        onChange={this.onNormalChange}
                        variant="outlined"
                        fullWidth
                    />
                </FormGroup>
            </div>
        )
    }
}

export default DisplayItemFileSettings
